import React from 'react';

interface FinancialKpiCardProps {
  label: string;
  value?: string;
  subtitle?: string;
  loading?: boolean;
  icon: React.ReactNode;
  iconBgClassName: string;
  iconClassName: string;
}

export default function FinancialKpiCard({
  label,
  value,
  subtitle,
  loading = false,
  icon,
  iconBgClassName,
  iconClassName,
}: FinancialKpiCardProps): JSX.Element {
  return (
    <div className="rounded-[12px] bg-secondary-200/70 p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{label}</p>
          {loading ? (
            <>
              <div className="mt-2 h-6 w-24 rounded bg-gray-200 animate-pulse" />
              <div className="mt-2 h-4 w-32 rounded bg-gray-100 animate-pulse" />
            </>
          ) : (
            <>
              {value && (
                <p className="text-2xl font-bold text-gray-900">
                  {value}
                </p>
              )}
              {subtitle && (
                <p className="text-sm text-gray-500">
                  {subtitle}
                </p>
              )}
            </>
          )}
        </div>
        <div className={iconBgClassName}>
          <span className={iconClassName}>{icon}</span>
        </div>
      </div>
    </div>
  );
}

